import React, { Component } from 'react';
import DateTime from 'react-datetime';
import Multiline from './../Multiline';
import Select from 'react-select';
import Core from './../../Core/Core';

class ClientForm extends Component
{
    constructor(props)
    {
        super(props);

        this.state = {
            "clients" : [],
            "maintenance_renault" : ''
        }

        this.onChange = props.onChange;
        
        this.handeInput = this.handeInput.bind(this);
        this.handleDate = this.handleDate.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.handleInputChange= this.handleInputChange.bind(this);
        this.handleRadio= this.handleRadio.bind(this);

        this.DateTimeBirth = React.createRef();

        this.timer = null;
        //this.state = this.props.client.maintenance_renault;
    }

    handleSelect(option, name)
    {
        let evt = {
            "target" : {
                "name" : name,
                "value" : option.value
            }
        };
        this.handeInput(evt);
    }

    handleRadio(event)
    {
        this.setState({
            "maintenance_renault" : event.target.value
        });
        this.handeInput(event);
    }

    handeInput(event)
    {
        let value = event.target.type === 'checkbox' ? (event.target.checked === true ? 1 : 0) : event.target.value;
        let evt = {
            "target" : {
                "name" : event.target.name,
                "value" : value
            } 
        }
        
        this.onChange(evt);
    }

    handleInputChange(value)
    {
        if(this.timer != null)
        {
            clearTimeout(this.timer);
            this.timer = null;
        }
        let params = value.split(" ").map((v) => {
            return "Client->name eq *"+v+"*";
        })

        if(value.length <= 0 || params.length <= 0)
            return;

        this.timer = setTimeout(() => {
            Core.Instance.Request(Core.Address+"Search/"+params.join(" and "), null, "GET")
            .then((json) => {
                this.setState({
                    "clients" : json != null ? json : []
                })
            })
        }, 1000);

    }

    handleDate(ref, name, date)
    {
        ref.current.querySelector('.text-danger').style.display = "none";
        ref.current.querySelector('.rdt .form-control').classList.remove("invalid")
        if(date._isAMomentObject == null)
        {
            ref.current.querySelector('.text-danger').style.display = "initial";
            ref.current.querySelector('.rdt .form-control').classList.add("invalid");
            let evt = {
                "target" : {
                    "name" : name,
                    "value" : null
                } 
            }
            this.onChange(evt);
            return;
        }
        else
        {
            let evt = {
                "target" : {
                    "name" : name,
                    "value" : date.unix()
                } 
            }
            this.onChange(evt);
        }
    }

    render()
    {
        let options = this.state.clients != null ? this.state.clients.map((e) => {
            return {
                "label" : e.name +" "+ e.first_name,
                "value" : e.id
            };
        }) : [];
        return (
            <form>
                <div className="row">
                    <div className="col">
                        <h4 className=" my-4" ><li className="fas fa-address-card"> </li> Coordonnées</h4>
                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                                Nom client
                            </label>
                            <input type="text" required maxLength="100" className="form-control" name="name" value={ this.props.client.name } onChange={ this.handeInput } />
                            <small className="text-danger form-text">
                                Ce champ est obligatoire et doit contenir moins de 100 caractères.
                            </small>
                        </div>

                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                                Prénom client
                            </label>
                            <input type="text" required maxLength="100" className="form-control" name="first_name" value={ this.props.client.first_name } onChange={ this.handeInput } />
                            <small className="text-danger form-text">
                                Ce champ est obligatoire et doit contenir moins de 100 caractères.
                            </small>
                        </div>

                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                                Société
                            </label>
                            <input type="text" maxLength="100" className="form-control" name="company" value={ this.props.client.company } onChange={ this.handeInput } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir moins de 100 caractères.
                            </small>
                        </div>

                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                                Siret
                            </label>
                            <input type="text" maxLength="100" className="form-control" name="siret" value={ this.props.client.siret } onChange={ this.handeInput } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir moins de 100 caractères.
                            </small>
                        </div>

                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                                Adresse
                            </label>
                            <input type="text" maxLength="100" className="form-control" name="address" value={ this.props.client.address } onChange={ this.handeInput } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir une adresse valide de moins de 100 caractères.
                            </small>
                        </div>

                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                                Code postal
                            </label>
                            <input type="text" maxLength="100" className="form-control" name="postal_code" value={ this.props.client.postal_code } onChange={ this.handeInput } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir une adresse valide de moins de 100 caractères.
                            </small>
                        </div>

                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                                Ville
                            </label>
                            <input type="text" maxLength="100" className="form-control" name="city" value={ this.props.client.city } onChange={ this.handeInput } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir une adresse valide de moins de 100 caractères.
                            </small>
                        </div>

                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                                Téléphone fixe
                            </label>
                            <Multiline name="phone" onChange={ this.handeInput } value={ this.props.client.phone } sep=" ; " pattern="(0|\\+33|0033)[1-9][0-9]{8}" />
                        </div>

                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                                Téléphone mobile
                            </label>
                            <Multiline name="phone_mobile" onChange={ this.handeInput } sep=" ; " value={ this.props.client.phone_mobile} pattern="(0|\\+33|0033)[1-9][0-9]{8}" />
                        </div>


                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                                Adresse(s) email
                            </label>
                            <Multiline name="email" onChange={ this.handeInput } sep=" ; " value={ this.props.client.email} pattern="^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$" />
                        </div>
                    </div>

                    <div className="col-6">
                        <h4 className="my-4" ><li className="fas fa-info-circle"> </li> Plus d'informations</h4>
                        <div className="row">
                            <div className="col">  
                                <div className="form-group" ref={ this.DateTimeBirth }>
                                    <label className="h5 font-weight-bold">
                                        Date de naissance
                                    </label>
                                    <DateTime name="date" timeFormat={ false } onChange={ (date) => { this.handleDate(this.DateTimeBirth, "birthdate", date)  } } dateFormat="DD/MM/YYYY" value={ this.props.client.birthdate != null ? this.props.client.birthdate*1000 : null } timeFormat={false} />
                                    <small className="text-danger form-text">
                                        Ce champ doit contenir une date valide
                                    </small>
                                </div>

                                <div className="form-group">
                                    <label className="h5 font-weight-bold">
                                        Lieu de naissance
                                    </label>
                                    <input type="text" maxLength="100" className="form-control" name="birth_address" value={ this.props.client.birth_address } onChange={ this.handeInput } />
                                    <small className="text-danger form-text">
                                        Ce champ doit contenir une adresse valide de moins de 100 caractères.
                                    </small>
                                </div>
                            
                                <div className="form-group">
                                    <label className="h5 font-weight-bold">
                                        Sexe
                                    </label>
                                    <select className="form-control" name="gender" value={ this.props.client.gender } onChange={ this.handeInput }>
                                        <option disabled selected value=""> -- Choisissez un sexe -- </option>
                                        <option value="0">HOMME</option>
                                        <option value="1">FEMME</option>
                                        <option value="2">NEUTRE</option>
                                    </select>
                                </div>

                                <div className="form-group">
                                    <label className="h5 font-weight-bold">
                                        Situation familiale
                                    </label>
                                    <select className="form-control" name="family" value={ this.props.client.family } onChange={ this.handeInput }>
                                        <option disabled selected value=""> -- Choisissez une situation -- </option>
                                        <option value="CELIBATAIRE">Célibataire</option>
                                        <option value="CONCUBINAGE">Concubinage</option>
                                        <option value="MARIE(E)">Marié(e)</option>
                                        <option value="PACSE(E)">Pacsé(e)</option>
                                        <option value="DIVORCE(E) SEPARE(E)">Divorcé/Séparé</option>
                                        <option value="VEUF(VE)">Veuf(ve)</option>
                                    </select>
                                </div>

                                <div className="form-group">
                                    <label className="h5 font-weight-bold">
                                        Décès
                                    </label>
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" name="dead" checked={ this.props.client.dead == 1 } onClick={ this.handeInput } id="dead" />
                                        <label className="form-check-label" htmlFor="dead">
                                            Décédé
                                        </label>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="h5 font-weight-bold">
                                        Immobilier
                                    </label>
                                    <select className="form-control" name="real_estate" value={ this.props.client.real_estate } onChange={ this.handeInput }>
                                        <option disabled selected value=""> -- Choisissez une situation -- </option>
                                        <option value="Propriétaire">Propriétaire</option>
                                        <option value="Locataire">Locataire</option>
                                    </select>
                                </div>

                                <div className="form-group">
                                    <label className="h5 font-weight-bold">
                                        Compatibilité ZE du client
                                    </label>
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" name="ze_compatible" checked={ this.props.client.ze_compatible == 1 } onClick={ this.handeInput } id="ze_compatible" />
                                        <label className="form-check-label" htmlFor="ze_compatible">
                                            client ZE compatible
                                        </label>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="h5 font-weight-bold">
                                        Profession
                                    </label>
                                    <input type="text" maxLength="100" className="form-control" name="profession" value={ this.props.client.profession } onChange={ this.handeInput } />
                                    <small className="text-danger form-text">
                                        Ce champ doit contenir une adresse valide de moins de 100 caractères.
                                    </small>
                                </div>

                                <div className="form-group">
                                    <label className="h5 font-weight-bold">
                                        Réseaux sociaux
                                    </label>
                                    <Multiline name="social_networks" onChange={ this.handeInput } value={ this.props.client.social_networks} />
                                </div>

                                <div className="form-group">
                                    <label className="h5 font-weight-bold">
                                        Animaux possédés
                                    </label>
                                    <input type="text" maxLength="100" className="form-control" name="animals" value={ this.props.client.animals } onChange={ this.handeInput } />
                                    <small className="text-danger form-text">
                                        Ce champ doit contenir une adresse valide de moins de 100 caractères.
                                    </small>
                                </div>

                                <div className="form-group">
                                    <label className="h5 font-weight-bold">
                                        Sports
                                    </label>
                                    <input type="text" maxLength="100" className="form-control" name="sports" value={ this.props.client.sports } onChange={ this.handeInput } />
                                    <small className="text-danger form-text">
                                        Ce champ doit contenir une adresse valide de moins de 100 caractères.
                                    </small>
                                </div>

                                <div className="form-group">
                                    <label className="h5 font-weight-bold">
                                        Loisirs / Activités culturelles
                                    </label>
                                    <input type="text" maxLength="100" className="form-control" name="hobbies" value={ this.props.client.hobbies } onChange={ this.handeInput } />
                                    <small className="text-danger form-text">
                                        Ce champ doit contenir une adresse valide de moins de 100 caractères.
                                    </small>
                                </div>
                            
                                <div className="form-group">
                                    <label className="h5 font-weight-bold">
                                        Composition du foyer
                                    </label>
                                    <Select name="household" options={ options } placeholder="Saisissez le nom d'un client" onInputChange={ this.handleInputChange } onChange={ (option) => { this.handleSelect(option, "household")  } } />
                                </div>

                                <div className="form-group">
                                    <label className="h5 font-weight-bold">
                                        Année de naissance des enfants
                                    </label>
                                    <Multiline name="children" onChange={ this.handeInput } value={ this.props.client.children } pattern="^(19|20)\d{2}$" />
                                </div>
                            </div>
                            <div className="col">
                                <div className="form-group">
                                    <label className="h5 font-weight-bold">
                                        Critères prioritaires dans le choix d'un véhicule
                                    </label>
                                    <Multiline name="criterias" onChange={ this.handeInput } value={ this.props.client.criterias} />
                                </div>
                                
                                <div className="form-group">
                                    <label className="h5 font-weight-bold">
                                        Equipements impératifs d'un futur véhicule
                                    </label>
                                    <Multiline name="useful_equipements" onChange={ this.handeInput } value={ this.props.client.useful_equipements} />
                                </div>

                                <div className="form-group">
                                    <label className="h5 font-weight-bold">
                                        Equipements interdits ou inutiles
                                    </label>
                                    <Multiline name="useless_equipements" onChange={ this.handeInput } value={ this.props.client.useless_equipements} />
                                </div>

                                <div className="form-group">
                                    <label className="h5 font-weight-bold">
                                        Expérience Renault
                                    </label>
                                    <select className="form-control" name="renault_experience" value={ this.props.client.renault_experience } onChange={ this.handeInput }>
                                        <option disabled selected value=""> -- Choisissez un type d'expérience -- </option>
                                        <option value="Fidèle">Fidèle</option>
                                        <option value="Perdu">Perdu</option>
                                        <option value="Conquête">Conquête</option>
                                        <option value="Partiel">Partiel</option>
                                    </select>
                                </div>

                                <div className="form-group">
                                    <label className="h5 font-weight-bold">
                                        Kilométrage moyen annuel 
                                    </label>
                                    <input type="number" min="0" max="999 999" className="form-control" name="avg_km" value={ this.props.client.avg_km } onChange={ this.handeInput } />
                                    <small className="text-danger form-text">
                                        Ce champ doit contenir un nombre entier entre 0 et 999 999.
                                    </small>
                                </div>

                                <div className="form-group">
                                    <label className="h5 font-weight-bold">
                                        Périodicité moyenne de renouvellement (en mois)
                                    </label>
                                    <input type="number" min="0" max="999" className="form-control" name="renewal" value={ this.props.client.renewal } onChange={ this.handeInput } />
                                    <small className="text-danger form-text">
                                        Ce champ doit contenir un nombre entier entre 0 et 999.
                                    </small>
                                </div>

                                
                                <div className="form-group">
                                    <label className="h5 font-weight-bold"> 
                                        Lieu d'entretien
                                    </label>
                                    <div className="form-check">
                                        <input className="form-check-input" type="radio" name="maintenance_renault"  value="1" checked={this.state.maintenance_renault == 1} onClick={ this.handleRadio } id="maintenanceRenault" />
                                        <label className="form-check-label" htmlFor="maintenanceRenault">
                                            Renault
                                        </label>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" type="radio" name="maintenance_renault"  value="0" checked={this.state.maintenance_renault == 0} onClick={ this.handleRadio } id="maintenanceOther" />
                                        <label className="form-check-label" htmlFor="maintenanceOther">
                                            Autre
                                        </label>
                                    </div>

                                    {
                                        this.state.maintenance_renault == 1 &&
                                        <div>
                                            <label className="h5 font-weight-bold">
                                                Avis
                                            </label>
                                            <input type="text" maxLength="100" className="form-control" name="renault_feedback" value={ this.props.client.feedback } onChange={ this.handeInput } />
                                            <small className="text-danger form-text">
                                                Ce champ doit contenir moins de 100 caractères.
                                            </small>
                                        </div>
                                    }
                                    {
                                        this.state.maintenance_renault == 0 &&
                                        <div>
                                            <label className="h5 font-weight-bold">
                                                Garage
                                            </label>
                                            <input type="text" maxLength="100" className="form-control" name="garage" value={ this.props.client.garage } onChange={ this.handeInput } />
                                            <small className="text-danger form-text">
                                                Ce champ doit contenir moins de 100 caractères.
                                            </small>
                                            <label className="h5 font-weight-bold">
                                                Commentaire
                                            </label>
                                            <input type="text" maxLength="100" className="form-control" name="garage_comment" value={ this.props.client.garage_comment } onChange={ this.handeInput } />
                                            <small className="text-danger form-text">
                                                Ce champ doit contenir moins de 100 caractères.
                                            </small>
                                        </div>
                                    }
                                </div>
                                <div className="form-group">
                                    <label className="h5 font-weight-bold"> 
                                        Attentes en matière de SAV
                                    </label>
                                    <input type="text" maxLength="100" className="form-control" name="apv_expectations" value={ this.props.client.apv_expectations } onChange={ this.handeInput } />
                                    <small className="text-danger form-text">
                                        Ce champ doit contenir une adresse valide de moins de 100 caractères.
                                    </small>
                                </div>

                                <div className="form-group">
                                    <label className="h5 font-weight-bold"> 
                                        Habitudes de financement APV
                                    </label>
                                    <select className="form-control" name="apv_funding" value={ this.props.client.apv_funding } onChange={ this.handeInput }>
                                        <option disabled selected value=""> -- Choisissez un mode de financement -- </option>
                                        <option value="Comptant">Comptant</option>
                                        <option value="Plusieurs fois">Plusieurs fois</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="col">
                        <h4 className=" my-4">
                            <li className="fas fa-phone-square"> </li> Etat
                        </h4>

                        <div className="form-check">
                            <input className="form-check-input" type="checkbox" name="active" checked={ this.props.client.active == 1 } onClick={ this.handeInput } id="defaultCheck1" />
                            <label className="form-check-label" htmlFor="defaultCheck1">
                                Actif
                            </label>
                        </div>

                        <div className="form-check">
                            <input className="form-check-input" type="checkbox" name="call_agree" checked={ this.props.client.call_agree == 1 } onClick={ this.handeInput } id="defaultCheck2" />
                            <label className="form-check-label" htmlFor="defaultCheck2">
                                Accord de communication téléphone
                            </label>
                        </div>

                        <div className="form-check">
                            <input className="form-check-input" type="checkbox" name="sms_agree" checked={ this.props.client.sms_agree == 1 } onClick={ this.handeInput } id="defaultCheck3"  />
                            <label className="form-check-label" htmlFor="defaultCheck3">
                                Accord de communication sms
                            </label>
                        </div>
                        <div className="form-check">
                            <input className="form-check-input" type="checkbox" name="mail_agree" checked={ this.props.client.mail_agree == 1 } onClick={ this.handeInput } id="defaultCheck4"  />
                            <label className="form-check-label" htmlFor="defaultCheck4">
                                Accord de communication mail
                            </label>
                        </div>
                        
                        {/* <h4 className="  my-4" ><li className="fas fa-heart"> </li> Affaire préférée Renault</h4>

                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                                My Renault
                            </label>
                            <input type="text" maxLength="100" className="form-control" name="my_renault" value={ this.props.client.my_renault } onChange={ this.handeInput } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir moins de 100 caractères.
                            </small>
                        </div>

                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                                My Dacia
                            </label>
                            <input type="text" maxLength="100" className="form-control" name="my_dacia" value={ this.props.client.my_dacia } onChange={ this.handeInput } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir moins de 100 caractères.
                            </small>
                        </div> */}
                    </div>
                </div>
            </form>
        );
    }
}

export default ClientForm;


// WEBPACK FOOTER //
// ./src/Components/Client/ClientForm.js